import React from 'react';
import { ThemeProvider } from '@emotion/react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { applyLogPrefix } from '@chronos/log';
import { ThemeContext } from '@chronos/ui-toolkit/contexts';
import themes from '@chronos/ui-toolkit/themes';

import config from 'app-config';

import store from './store';
import AppContainer from './containers/AppContainer';
import GlobalStyles from './styled/styled-global';

const rootEl = window.document.getElementById('app');
const root = createRoot(rootEl);

log.setLevel(config.logLevel);
applyLogPrefix('🧪[test-app]');

const getPreferredTheme = () => {
  const prefersDark =
    window.matchMedia &&
    window.matchMedia('(prefers-color-scheme: dark)').matches;
  return prefersDark ? themes.dark : themes.light;
};

const initialTheme = getPreferredTheme();

const render = (Component) =>
  root.render(
    <Provider store={store}>
      <ThemeContext.Provider value={initialTheme}>
        <ThemeProvider theme={initialTheme}>
          <GlobalStyles />
          <Component />
        </ThemeProvider>
      </ThemeContext.Provider>
    </Provider>
  );

render(AppContainer);
